<template>
    <header>
        <div class="container-fluid d-flex justify-content-between">
            <div class="header-left">
                <!-- 로고 -->
                <h1 class="site-name" :class="title !== '예스콘' ? 'mobile-none' : ''">
                    <a href="/" class="logo">
                        <img class="tablet-none" src="@/assets/img/logo-animation.gif" alt="예스콘">
                        <span class="pc-none visually-hidden">예스콘</span>
                        <LogoYescon class="pc-none" />
                    </a>
                </h1>
                <!-- 뒤로가기 -->
                <template v-if="title !== '예스콘'" >
                <slot name="left" :class="{'pc-none': title !== '예스콘'}">
                    <button class="i-btn btn-back" @click="back" aria-label="뒤로가기">
                        <IconBack></IconBack>
                    </button>
                </slot>
                </template>

                <!-- 페이지 타이틀 -->
                <template v-if="title !== '예스콘'">
                    <h2 class="page-title">{{ title }}</h2>
                </template>
            </div>

            <!-- Search 섹션 --> <!-- :class="{'short': title !== '예스콘'}" -->
            <div class="search-section short">
                <div id="searchWrap" class="search-wrap">
                    <slot>
                        <button class="btn-search-back" @click="closeSearchLayer" aria-label="검색창 끄기">
                            <IconBack></IconBack>
                        </button>
                    </slot>

                    <input type="search" v-model="search" id="searchInput" class="search-input" ga-attr-data="search-keyword" spellcheck="false" autocomplete="off"
                        @input.prevent="handleSearchInput" @keypress.enter="doSearch" @focus.prevent="searchFocus" placeholder="전체 상품 검색">
                    
                    <!-- 검색 input이 보이지 않을 때 돋보기 버튼 -->
                    <SearchMoreOpenBtn></SearchMoreOpenBtn>

                    <!-- 검색 input UI에 함께 있는 돋보기 버튼 -->
                    <button @click="doSearch" type="button" aria-label="검색하기" id="submitBtn" class="i-search">
                        <IconSearchPrimary></IconSearchPrimary>
                    </button>
                </div>
                <SearchMore class="mobile-none" 
                    :search="search"
                    :savedRecentKeyword="savedRecentKeyword"
                ></SearchMore>
            </div>

            <!-- 별도 레이어팝업 테스트--> 
            <!-- <template v-if="isMobileClickSearch">
            <SearchLayerPopup></SearchLayerPopup>
            </template> -->



            <!-- // Search 섹션 -->

            <!-- 프로필 게이트 -->
            <div class="header-right">
                <a href="/service" class="i-btn i-question" aria-label="예스콘 서비스 소개" title="예스콘 서비스 소개">                    
                    <img src="@/assets/img/icon_question_primary.svg" alt="">
                </a>
                <ProfileMyGate></ProfileMyGate>
            </div>
        </div>
    </header>
</template>

<script>
// import { userNoExpiredTimePerSeconds } from '@/util.js';
import { eventBus } from '@/event/index.js';
import { mapState } from 'vuex';

export default {
    
    components: {
        SearchMore: () => import('@/components/header/SearchMore.vue'),                 // 검색키워드 확장영역
        // SearchLayerPopup: () => import('@/components/header/SearchLayerPopup.vue'),  // 검색키워드 모바일 팝업
        ProfileMyGate: () => import('@/components/header/ProfileMyGate.vue'),           // 프로필 게이트
        LogoYescon: () => import('@/components/svg-icon/LogoYescon.vue'),               // 로고
        IconBack: () => import('@/components/svg-icon/IconBack.vue'),                   // 뒤로가기 아이콘
        SearchMoreOpenBtn: () => import('@/components/header/SearchMoreOpenBtn.vue'),   // 검색 input open 버튼
        IconSearchPrimary: () => import('@/components/svg-icon/IconSearchPrimary.vue'), // 돋보기 아이콘
    },

    props: {
        hasLeft: { type: Boolean, default: true },
        title: { type: String, default: '' },
    },

    data() {
        return {
            search: '',                             // search input v-model
            regExpRemoveSpace: /\s/g,               // 공백제거 정규식 

            // stageInfoList: [],
            // isMobileClickSearch: false ,
            recentKeyword:[] ,                      // 최근 검색어
            savedRecentKeyword:[],                  // 최근 검색어

            SEARCH_KEWYORD_KEY: 'searchKeyword',    // 
        }
    },

    created() {
        eventBus.$off('currKeywords');  // 이벤트버스 중복호출 방지
        eventBus.$on('currKeywords', this.getCurrKeywords);
        this.savedRecentKeyword = JSON.parse(localStorage.getItem(this.SEARCH_KEWYORD_KEY));
    },

    computed: {
        ...mapState({
            userNo: state => state.userNo,
            vuexSearch : state => state.searchStore.vuexSearch,
        }),

        // loginLimitTime(){
        //     if(this.userNo){
        //         return userNoExpiredTimePerSeconds(this.userNo) - Math.floor(new Date().getTime() / 1000);
        //     }else{
        //         return null;
        //     }
        // }
    },

    mounted(){
        if(this.$route.name === 'search'){
            if (this.vuexSearch.includes(',')) {                    // if 검색어에 공백이 포함
                this.search = this.vuexSearch.replace(',', ' ');    // 띄어쓰기를 , 로 치환
            }else{
                this.search = this.vuexSearch;
            }
        }
        // console.log('this.loginLimitTime: ', this.loginLimitTime);
    },

    watch: {
        // loginLimitTime(){
        //     console.log(this.loginLimitTime);
        //     if(this.loginLimitTime === 0){
        //         alert('로그인 유효시간이 만료되었습니다.')
        //         sessionStorage.removeItem('access-token');
        //         //location.reload();
        //         return;        
        //     }
        // },
    },

    methods: {
        // start: Search 섹션
        getCurrKeywords(value) {
            this.search = value;
            // console.log('getCurrKeywords', this.search);
            this.getData();
        },

        back() { // 뒤로가기
            this.$router.back();
        },
        
        // Back : 모바일 검색창 레이어 화면 닫기
        closeSearchLayer() {
            // this.$router.back(); //뒤로가기 기능
            const searchSection = document.querySelector('.search-section'); // 입력폼과 버튼을 감싸는 부모요소
            const searchMore = document.querySelector('#searchMore'); // 검색 확장 영역

            // if(this.title !== '예스콘'){
            //     searchSection.classList.replace('change', 'short');
            // }else{
            //     searchSection.classList.remove('change');
            // }

            searchSection.classList.replace('change', 'short');
            // searchSection.classList.remove('change');
            // searchSection.classList.add('short');
            searchMore.classList.remove('active');
            document.querySelector('header').style.minHeight = 'auto';
        },

        // 입력폼 마우스 포커스 시 함수
        searchFocus() { 
            const searchMore = document.querySelector('#searchMore'); // 검색 확장 영역
            const searchSection = document.querySelector('.search-section'); // 입력폼과 버튼을 감싸는 부모요소

            searchMore.classList.add('active');

            if (screen.width <= 768) { // 모바일
                // // console.log(screen.width);
                searchSection.classList.add('change');
                document.querySelector('header').style.minHeight = '100vh';
            }
            else if (screen.width > 768) { // 태블릿, PC 
                // // console.log(searchMore.offsetHeight + 'px');
                setTimeout(() => {
                    searchSection.classList.add('change');
                    searchMore.style.transition = 'all .3s';
                    searchMore.style.transitionDelay = '.3s';
                    searchMore.style.minHeight = '500px';
                    // searchSection.style.borderRadius = '12px';
                }, 300);
            }

            // 서치폼 외부영역 클릭 시
            document.addEventListener('click', clickBodyEvent);
            function clickBodyEvent(event) {
                const target = event.target;
                const point = event.currentTarget.querySelector(".search-section");
                
                if (target.closest('.search-section') !== point) {
                    searchMore.style.minHeight = '0';
                    setTimeout(() => {
                        searchSection.classList.remove('change');
                        // searchSection.style.borderRadius = '56px';
                    }, 500);
                }
            }
        },
        
        // 검색하기 이벤트 발생
        doSearch() {
            if(this.$cookies.isKey('autoSaveStatus') && this.$cookies.get('autoSaveStatus') === 'ON') {
                this.processRecentKeyword();
            }

            this.detectDomSearchInputValue();
            
            this.getData();
        },

        // 검색어 입력 후 기능
        handleSearchInput(event) {
            this.search = event.target.value;
        },

        // 쿼리값이나 파라미터 등으로 data 직접 적용이 아닌 dom input value에 만 값을 넣어둔 경우 
        // 공백 정제해서 data 변수에 저장
        detectDomSearchInputValue(){
            const searchInputValue = document.querySelector('#searchInput').value;
            if(searchInputValue){                
                this.search = this.removeUnnecessarySpace(searchInputValue);
            }
        },

        // 테스트 상품 검색 데이터 가져오기
        getData() {
            let keywords = this.search;

            // only 공백만 있다면
            if(this.search.replace(this.regExpRemoveSpace, '').length === 0){
                return;
            }

            // 검색어에 공백이 포함
            if (this.search.match(this.regExpRemoveSpace)) {
                this.search = this.removeUnnecessarySpace(this.search);
                keywords = this.search.replace(this.regExpRemoveSpace, ',') // 띄어쓰기를 , 로 치환
            } else {
                // 공백이 없다면
                keywords = this.search;
            }

            // vuex commit 등록
            this.$store.commit('searchStore/setVuexSearch', this.search);
                            
            // 키워드 검색 후 동일한 키워드 재 검색시 콘솔오류 안뜨게
            this.$router.push({name:"search", query: {data: keywords}}).catch(()=>{
                
                // 검색어가 같을 경우 새로고침 처리
                if(this.$route.query.data === keywords){
                    this.$router.go();
                }
            })
        },

        // 검색어의 다중공백, 앞공백, 뒷공백 제거
        removeUnnecessarySpace(str) {
            let result = '';

            // 다중 공백을 단일 공백으로 치환
            str = str.replace(/ +/g, ' '); 

            // 앞 뒤 공백 제거
            if(str.charAt(0).match(this.regExpRemoveSpace) || str.charAt(str.length - 1).match(this.regExpRemoveSpace) ) {
                result = this.search.replace(/^\s+|\s+$/gm, '');
                return result;
            }else{
                return str;
            }
        },

        // 최근 검색어 처리
        processRecentKeyword() {
            this.search = this.removeUnnecessarySpace(this.search);

            const recentKeywordObj = {
                id: Date.now(),
                keyword: this.search
            }
            
            // 기존 저장된 키워드가 존재하는가?
            if(Array.isArray(this.savedRecentKeyword) && this.savedRecentKeyword.length !== 0) {
                if(this.savedRecentKeyword.length === 10) {
                    // 키워드가 10개일 경우 제일 오래된 키워드를 제거함.
                    this.recentKeyword = this.removeOldKeyword(this.savedRecentKeyword);
                } else {
                    this.recentKeyword = this.savedRecentKeyword; 
                }
            } 
            
            // 키워드가 중복되지 않을때만 저장
            if(!this.checkDuplicationKeyword(recentKeywordObj)) {
                this.recentKeyword.push(recentKeywordObj);
                this.saveSearchKeywordToLocalStorage();
            }
        },

        // 최근검색어 중 오래된 검색어 순차적 제거
        removeOldKeyword() {
            let removedOldRecentKeyword = this.savedRecentKeyword.filter((_item, index) => index > 0);
            return removedOldRecentKeyword;
        },

        // 검색어 스토리지 저장
        saveSearchKeywordToLocalStorage() {
            typeof(Storage) !== 'undefined' && localStorage.setItem(this.SEARCH_KEWYORD_KEY, JSON.stringify(this.recentKeyword));
        },
        
        // 중복 키워드 체크
        checkDuplicationKeyword(recentKeywordObj) {
            return this.recentKeyword.some((item) => item.keyword === recentKeywordObj.keyword); 
        },
        
        // end: Search 섹션
    }
}

</script>

<style lang="scss" scoped>
@import '@/assets/css/header.scss'; /* Header css */




</style>